module.exports = __webpack_public_path__ + "static/img/pic_img.71065e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_img.jpg
// module id = RRq7
// module chunks = 34